import { NgModule } from "@angular/core";
import { CommonModule, registerLocaleData } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { DragDropModule } from "@angular/cdk/drag-drop";
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  HttpClientModule,
} from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { OverlayModule } from "@angular/cdk/overlay";
import { NgZorroAntdModule, NZ_I18N, zh_CN, NZ_ICONS } from "ng-zorro-antd";
import { ColorPickerModule } from "ngx-color-picker";
import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  MinusSquareFill,
  MinusSquareOutline,
  MinusSquareTwoTone,
  MinusOutline,
  InboxOutline,
} from "@ant-design/icons-angular/icons";

import zh from "@angular/common/locales/zh";

import { KreFormModule, Default_CODE } from "@kre-form/core";
import {
  BOOTSTRAP_KreFORM_CONFIG,
  FIELD_TYPE_COMPONENTS,
} from "./bootstrap.config";

import { validationConfig } from "./validation.config";
import { KreFormDesignDetail } from "./design/detail/detail.component";
import { KreFormDesignDetailX } from "./design/detail2/index.component";
import { KreFormDSField } from "./design/field/index.component";
import { KreFormDSFieldLabel } from "./design/field-label/index.component";
import { KreFormDSFieldType } from "./design/field-type/index.component";
import { KreFormDesignTable } from "./design/table/table.component";
import { KreFormDesignTables } from "./design/tables/table.component";
import { KreFormDrawerComponent } from "./design/drawer/index.component";

import { KreFormPrivateTree } from "./components/private/tree/index.component";
import { KreFormPrivateTable } from "./components/private/table/index.component";

import { KreFormFieldPrivateText } from "./types/private_text";

import { KreFormTree } from "./components/tree/index.component";
import { KreFormEmployee } from "./components/employee/index.component";
import { KreFormOrg } from "./components/org/index.component";
import { KreFormPostion } from "./components/postion/index.component";
import { KreFormArea } from "./components/area/index.component";
import { KreFormFieldButton } from "./components/fieldbutton/index.component";

// import { KreLanguageComponent } from "./components/public/lang/index.component";
// import { KreFormEmployeeComponent } from "./components/public/employee/index.component";
// import { KreFormOrgComponent } from "./components/public/org/index.component";
// import { KreFormPostionComponent } from "./components/public/postion/index.component";
// import { KreFormAreaComponent } from "./components/public/area/index.component";
// import { KreCardSelfComponent } from "./components/public/card/card-self/index.component";
// import { KreCardSubComponent } from "./components/public/card/card-sub/index.component";
// import { KreCardEmpComponent } from "./components/public/card/card-emp/index.component";
// import { KreCardLimitComponent } from "./components/public/card/card-limit/index.component";

import { KreFormAntService } from "./tools/service";
import { KreToFormFieldService } from "./tools/formFieldService";
import { KreDesginToFormService } from "./tools/tableFieldService";

import { ReplaceLinePipe } from "./tools/replaceLinePipe";
import { _HttpClient } from "./net/http.client";
import { TriggerComponent } from "./design/trigger/trigger.component";
import { EventComponent } from "./design/event/event.component";
import { EventItemComponent } from "./design/event/event-item/event-item.component";
import { TextEnComponent } from "./design/text-en/text-en.component";
import { DatetimeComponent } from "./design/event/datetime/datetime.component";
import { DeonCodemirrorModule } from "@kre-form/abc";
import { ConfigCodemirrorComponent } from "./design/config-codemirror/config-codemirror.component";

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  MinusSquareFill,
  MinusSquareOutline,
  MinusSquareTwoTone,
  MinusOutline,
  InboxOutline,
];
registerLocaleData(zh);

//私有的
const entryComponent = [
  KreFormDSField,
  KreFormDSFieldLabel,
  KreFormDSFieldType,
  KreFormDesignTable,
  KreFormDesignTables,
  KreFormDrawerComponent,

  KreFormPrivateTree,
  KreFormPrivateTable,

  KreFormTree,
  KreFormEmployee,
  KreFormEmployee,
  KreFormOrg,
  KreFormPostion,
  KreFormArea,
  KreFormFieldButton,
  EventComponent,
  EventItemComponent,
  ConfigCodemirrorComponent,
  KreFormFieldPrivateText,
];

//公开的
const publicComponent = [
  KreFormDesignDetail,
  KreFormDesignDetailX,
  KreFormFieldButton,
  TriggerComponent,
  // KreLanguageComponent,
  // KreFormEmployeeComponent,
  // KreFormOrgComponent,
  // KreFormPostionComponent,
  // KreFormAreaComponent,
  // KreCardSelfComponent,
  // KreCardSubComponent,
  // KreCardEmpComponent,
  // KreCardLimitComponent,
];

@NgModule({
  declarations: [
    FIELD_TYPE_COMPONENTS,
    entryComponent,
    publicComponent,
    ReplaceLinePipe,
    TextEnComponent,
    DatetimeComponent,
  ],
  imports: [
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    DragDropModule,
    OverlayModule,
    NgZorroAntdModule,
    ColorPickerModule,
    DeonCodemirrorModule,
    KreFormModule.forChild(BOOTSTRAP_KreFORM_CONFIG),
    KreFormModule.forRoot(validationConfig),
  ],
  entryComponents: [entryComponent],
  exports: [TranslateModule, publicComponent],
  providers: [
    { provide: NZ_I18N, useValue: zh_CN },
    { provide: NZ_ICONS, useValue: icons },
    _HttpClient,
    //KreFormAntService,
    KreToFormFieldService,
    KreDesginToFormService,
  ],
})
export class KreFormAntModule {}
